import Select from "react-select"
import cn from "classnames"
import customStyles from "./styles"

const RATE_TYPES = [
  {
    value: 0,
    label: "By Gallon/Unit",
  },
  {
    value: 1,
    label: "By Mile",
  },
  {
    value: 2,
    label: "Flat Fee",
  },
] as any

const RateTypePicker = (props: {
  selected?: number
  flush?: boolean
  isDisabled?: boolean
  className?: string
  label?: string
  onSelect?: (item: any) => void
}) => {
  const styles = props.flush ? { marginRight: 0 } : {}
  return (
    <div className={cn("flex-c-box", props.className)}>
      {!props.label ? null : (
        <>
          <span style={{ color: "#486f88", fontWeight: "bold" }}>
            {props.label}
          </span>
          <div style={{ marginTop: 8 }} />
        </>
      )}

      <Select
        isDisabled={props.isDisabled}
        placeholder="Choose Type"
        options={RATE_TYPES}
        onChange={props.onSelect}
        styles={customStyles(styles)}
        defaultValue={RATE_TYPES?.find(
          (item: any) => item.value === props.selected
        )}
      />
    </div>
  )
}

export default RateTypePicker
